import { useLocale } from "@/i18n/LocaleContext";

export const Marquee = () => {
  const { t } = useLocale();
  const loop = [...t.marquee, ...t.marquee];
  return (
    <section className="relative border-y border-white/10 py-10 md:py-14 overflow-hidden" data-testid="marquee-section">
      <div className="flex whitespace-nowrap w-max animate-marquee">
        {loop.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-playfair italic text-outline text-6xl md:text-8xl px-8">{item}</span>
            <span className="text-nowi-venture text-4xl md:text-6xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
};
